// extracted by mini-css-extract-plugin
module.exports = {"tasksContainer":"tasks_tasksContainer__2E7vu"};